import EditInvoiceSettingsForm from './EditInvoiceSettingsForm';

export default EditInvoiceSettingsForm;
